import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTypography,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
} from 'mdbreact';
import React, { useRef, useState, useContext } from 'react';
import { UserContext } from '../UserContext';
import DataTable from '../DataTable';
import CategoryWiseTable from '../CategoryWiseTable';

function Search() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);
  const columns = [
    { name: 'Activity' },
    { name: 'Category' },
    { name: 'Hours' },
    { name: 'Event Date' },
  ];
  const [roll, setRoll] = useState('');
  const [studentData, setStudentData] = useState('atStart');
  const studentRollNoRef = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const activityNameRef = useRef(null);
  const categoryRef = useRef(null);
  const eventDateRef = useRef(null);
  const hoursRef = useRef(null);

  const deleteEventForStudent = () => {
    fetch(`${baseURL}/api/admin/user/delete_event_for_user`, {
      method: 'DELETE',
      body: JSON.stringify({
        display_name: activityNameRef.current.value,
        event_date: eventDateRef.current.value,
        category: categoryRef.current.value,
        email: studentData.info.email_id,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert('Event deleted for student succesfully');
          // window.location.reload();
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
        }
      })
      .catch((err) => {
        alert('DELETE failed, try later');
        console.log(err);
      });
  };

  const getEventsForId = (event) => {
    event.preventDefault();
    const rollNum = studentRollNoRef.current.value;
    setRoll(rollNum);
    fetch(`${baseURL}/api/user/${rollNum}`)
      .then((res) => {
        if (res.status >= 400) {
          setStudentData('NotExisting');
        } else {
          res.json().then((result) => setStudentData(result));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const openActivityPopup = (rowData) => {
    setIsPopupOpen(true);
    const fillData = setInterval(() => {
      activityNameRef.current.value = rowData[0];
      categoryRef.current.value = rowData[1];
      hoursRef.current.value = rowData[2];
      eventDateRef.current.value = rowData[3];
      clearInterval(fillData);
    }, 100);
  };

  const closeActivityPopup = () => {
    setIsPopupOpen(false);
  };

  const modifyActivity = (event) => {
    event.preventDefault();
    if (userContext.name === '') {
      alert('Not Authorized');
      return;
    }

    fetch(`${baseURL}/api/admin/activity/hours`, {
      method: 'PATCH',
      body: JSON.stringify({
        display_name: activityNameRef.current.value,
        event_date: eventDateRef.current.value,
        category: categoryRef.current.value,
        hours: hoursRef.current.value,
        email: studentData.info.email_id,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert('Hours modified succesfully');
          // window.location.reload();
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
        }
      })

      .catch((err) => {
        alert('POST Request Failed, Please try again later');
        console.log(err);
      });
  };

  return (
    <>
      <MDBModal isOpen={isPopupOpen} toggle={closeActivityPopup}>
        <MDBModalHeader toggle={closeActivityPopup}>
          <p className="h3 mt-2">Edit Student Activity</p>
        </MDBModalHeader>
        <MDBModalBody>
          <form onSubmit={modifyActivity}>
            <label htmlFor="activity-name" className="black-text">
              Activity Name
            </label>
            <input
              type="text"
              id="activity-name"
              className="form-control"
              ref={activityNameRef}
              readOnly
            />
            <br />
            <label htmlFor="category" className="black-text">
              Category
            </label>
            <input
              type="text"
              id="category"
              className="form-control"
              ref={categoryRef}
              readOnly
            />
            <br />
            <label htmlFor="date" className="black-text">
              Event Date
            </label>
            <input
              type="text"
              id="date"
              className="form-control"
              ref={eventDateRef}
              readOnly
            />
            <br />
            <label htmlFor="hours" className="black-text">
              Hours
            </label>
            <input
              type="number"
              id="hours"
              className="form-control"
              ref={hoursRef}
              required
            />
            <br />
            <div className="text-center mt-4">
              <MDBBtn color="primary" type="submit">
                Update
              </MDBBtn>
              <MDBBtn color="red" onClick={deleteEventForStudent}>
                Delete
              </MDBBtn>
            </div>
          </form>
        </MDBModalBody>
      </MDBModal>
      <MDBContainer style={{ marginBottom: '1.5rem' }} fluid>
        <MDBRow center>
          <MDBCol md="6">
            <form onSubmit={getEventsForId}>
              <p className="h2 text-center mb-4">User Lookup</p>
              <label htmlFor="roll-num" className="black-text">
                Roll Number
              </label>
              <input
                type="text"
                id="roll-num"
                className="form-control"
                placeholder="Roll Number"
                ref={studentRollNoRef}
                required
              />
              <MDBBtn color="primary" type="submit">
                Search
              </MDBBtn>
            </form>
          </MDBCol>
        </MDBRow>
        {(() => {
          if (studentData === 'NotExisting') {
            return (
              <MDBRow center>
                <MDBTypography note noteColor="danger" noteTitle="Error : ">
                  The queried Student &nbsp;
                  {roll}
                  {' '}
                  does not exist.
                </MDBTypography>
              </MDBRow>
            );
          }
          if (studentData === 'atStart') return <></>;
          return (
            <>
              <MDBRow center>
                <MDBTypography note noteColor="light" noteTitle="User Details">
                  <br />
                  Name : &nbsp;
                  {' '}
                  {studentData.info.display_name}
                  <br />
                  Email : &nbsp;
                  {' '}
                  {studentData.info.email_id}
                  <br />
                  Active: &nbsp;
                  {' '}
                  {studentData.info.is_active.toString()}
                  <br />
                </MDBTypography>
              </MDBRow>
              <MDBRow center>
                <CategoryWiseTable eventData={studentData.activities} />
              </MDBRow>
              <DataTable
                tableName={`Activitites for ${roll}`}
                data={studentData.activities}
                columns={columns}
                // error={Error}
                options={{
                  rowsPerPage: 15,
                  rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
                  onRowClick: openActivityPopup,
                }}
              />
            </>
          );
        })()}
      </MDBContainer>
    </>
  );
}

export default Search;
